export default "__VITE_ASSET__62402d14__"